import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
// Components
import Modal from 'app/views/components/UIkit/Modal'
import { CryptoModalContainer } from 'app/views/containers/Organizations/Rewards/style';

import { getRewardsCatalogByOrganization, getRewardsCardsCatalogue } from 'app/state/modules/rewards'
import Loader from '../../Loader';

const ModalGiftCard = (props) => {
  const { title } = props;
  let { loadingCatalogByOrganization } = props
  if (props.type === 'allAvailable') {
    loadingCatalogByOrganization = props.loadingRewardsCatalogue
  }
  const giftCardCatalogue = props.type === 'allAvailable' ?
    props.giftCardCatalogue
    :
    (props.catalogByOrganizationId[props.match.params.organization_uuid] || {}).giftCard || []
  const cryptoCatalogue = (props.catalogByOrganizationId[props.match.params.organization_uuid] || {}).crypto || []
  useEffect(() => {
    if (props.type === 'allAvailable') {
      props.getRewardsCardsCatalogue()
    } else if (title === 'Gift Card Options' && !giftCardCatalogue && !loadingCatalogByOrganization) {
      props.getRewardsCatalogByOrganization(props.match.params.organization_uuid)
    } else if (title === 'Crypto Options' && !cryptoCatalogue) {
      props.getRewardsCatalogByOrganization(props.match.params.organization_uuid)
    }
  }, [...(props.type === 'allAvailable' ? [] : [title, loadingCatalogByOrganization, giftCardCatalogue])])
  const renderBody = () => {
    if (title === "Gift Card Options" && (loadingCatalogByOrganization || !giftCardCatalogue)) {
      return <Loader visible text="Loading" />
    }
    if (title === "Gift Card Options" || props.type === 'allAvailable') {
      return (
        <div className="uk-padding-small">
          <div className={`uk-flex uk-flex-row uk-flex-wrap uk-flex-${(giftCardCatalogue || []).length < 5 ? 'start' : 'around'} uk-flex-middle`}>
            {(giftCardCatalogue || []).map(card => {
              return (
                <React.Fragment key={`${card.giftCard.metadata.tangoReward.brandKey}-${card.giftCard.metadata.tangoReward.utid}`}>
                  <div
                    className={`uk-card uk-card-body uk-position-relative uk-background-cover uk-card-default uk-margin-bottom ${(giftCardCatalogue || []).length < 5 ? 'uk-margin-small-left uk-margin-small-right' : ''}`}
                    style={{ backgroundImage: `url(${card.giftCard.metadata.imageUrls["200w-326ppi"]})`, height: 125, borderRadius: 20, width: 200 }}
                  >
                    <div
                      className="uk-background-default uk-position-bottom uk-padding-small-left uk-padding-small-right"
                      style={{ height: 25, borderBottomLeftRadius: 20, borderBottomRightRadius: 20, borderTop: 'solid 1px rgba(0,0,0,0.2)' }}
                    >
                      <p className="uk-margin-remove-top uk-margin-remove-bottom uk-text-small uk-text-emphasis uk-text-truncate uk-text-emphasis uk-text-center uk-margin-small-left uk-margin-small-right">
                        {card.giftCard.name}
                      </p>
                    </div>
                  </div>
                </React.Fragment>
              )
            })}
          </div>
          <button
            className="uk-modal-close-outside"
            data-uk-close
            type="button"
          />
        </div >
      )
    }
    if (title === "Crypto Options") {
      return (
        <div className="uk-flex uk-flex-row uk-flex-middle uk-flex-around uk-flex-wrap uk-margin-large-right uk-padding-large">
          {cryptoCatalogue.map((cryp) => {
            let image
            if (cryp.crypto.asset === 'BTC') {
              image = '/static/images/crypto1.png'
            }
            if (cryp.crypto.asset === 'DOGE') {
              image = '/static/images/crypto2.png'
            }
            return (
              <div className="uk-flex uk-flex-column uk-flex-center uk-flex-middle" key={cryp.crypto.asset}>
                <img src={image} alt="crypto1" width="200" />
                <p className="uk-text-emphasis">{cryp.crypto.asset}</p>
              </div>
            )
          })}
          <button
            className="uk-modal-close-outside"
            data-uk-close
            type="button"
          />
        </div>

      )
    }
    if (title === "T Shirt Options") {
      return (
        <CryptoModalContainer>
          <div className="crypto">
            <img src="/static/images/tshirt.png" alt="tshirt" width="100%" />
          </div>
          <button
            className="uk-modal-close-outside"
            data-uk-close
            type="button"
          />
        </CryptoModalContainer>
      )
    }
  }
  const width = title === "Crypto Options" ? 'uk-width-2-3' : 'uk-width-4-5'
  return (
    <Modal
      width={width}
      id={props.id || 'modal-gift-cards'}
      title={title}
      body={(
        renderBody()
      )}
    />
  )
}

const mapStateToProps = ({ rewards }) => ({
  catalogByOrganizationId: rewards.catalogByOrganizationId,
  loadingCatalogByOrganization: rewards.loadingCatalogByOrganization,

  giftCardCatalogue: rewards.giftCardCatalogue,
  loadingRewardsCatalogue: rewards.loadingRewardsCatalogue,
})

export default withRouter(connect(mapStateToProps, {
  getRewardsCatalogByOrganization,
  getRewardsCardsCatalogue,
})(ModalGiftCard))
